import { Modal } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Form, Formik, FormikHelpers } from 'formik'

import { GenerateForm } from './generate-form.component'
import { useGeneratedDescription } from 'src/hooks'
import { AIGenerateContentPrompt, IAIGenerateFormValues } from 'src/types'

import { generateDescriptionSchema } from 'src/common/validations'
import { useStyles } from './styles'

interface IGenerateModalProps {
  handleAddition: (value: string) => void
  isOpen: boolean
  handleClose: () => void
  generationType: AIGenerateContentPrompt
  textPrompt?: string
  locale?: string
}

const initialValues = {
  description: '',
  generatedDescription: '',
}

const GenerateModal = ({
  handleAddition,
  isOpen,
  handleClose,
  generationType,
  textPrompt,
  locale,
}: IGenerateModalProps) => {
  const [t] = useTranslation()
  const { mutateAsync } = useGeneratedDescription(generationType, locale)
  const classes = useStyles()

  const handleSubmit = async (
    values: IAIGenerateFormValues,
    helpers: FormikHelpers<IAIGenerateFormValues>,
  ) => {
    values.generatedDescription = t('loading-text-notification.v')

    const resp = await mutateAsync(values.description)
    if (!resp) {
      values.generatedDescription = 'Something went wrong. Please try again.'
      return
    }

    helpers.setFieldValue('generatedDescription', resp)
  }

  return (
    <Modal open={isOpen} onClose={handleClose} className={classes.modal}>
      <>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={generateDescriptionSchema}
          initialErrors={{ description: '' }}
        >
          <Form>
            <GenerateForm
              textPrompt={textPrompt}
              handleClose={handleClose}
              handleAddition={handleAddition}
            />
          </Form>
        </Formik>
      </>
    </Modal>
  )
}

export { GenerateModal }
